export default {
    crop: {
        title: "Avling",
        cropSize: "Beskjæringsstørrelse",
        zoom: "Zoom",
        custom: 'Tilpasset',
        post: 'Post',
        square: 'Kvadrat',
        landscape: 'Landskap',
        story: 'Historie',
        portrait: 'Portrett',
        carousel: 'Karusell',
        commonAspectRatio: 'Vanlig sideforhold',
    },
};
